import React, { useCallback, useState } from 'react';

import { MenuItem } from '@material-ui/core';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import DropdownListElements from 'components/DropdownListElements/DropdownListElements';
import styled, { css } from 'styled-components';
import { isEmptyObject } from 'styles/common';

import { EmployeeIconCircleIcon } from 'constants/icons';
import { sendAppliedFilterEvent } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import FilterDisplay from './FilterDisplay';
import { getFunctionForSortingSelectedAtTop } from './helper';
import { ScrollableContainer } from './styles';

const StyledDropdownList = styled(DropdownList)`
  margin-top: 15px;
  ${(props) => css`
    &:after {
      content: ' ';
      width: 0px;
      height: 10px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 9px solid ${theme.palette.background.paper};
      display: inline-block;
      position: absolute;
      transform: rotate(180deg);
      left: 30%;
      top: -10px;
      z-index: 999;
    }
  `};
`;

const DropdownListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

const EMPLOYEE_FILTER_SELECT = 'EMPLOYEE_FILTER_SELECT';
export const EMPLOYEE_FILTER_UPDATE = 'EMPLOYEE_FILTER_UPDATE';
const EMPLOYEE_FILTER_CLEAR = 'EMPLOYEE_FILTER_CLEAR';

export function employeeFilterReducer(state = {}, action) {
  switch (action.type) {
    case EMPLOYEE_FILTER_SELECT: {
      const newState = { ...state };
      newState[action.value] = !newState[action.value];
      return newState;
    }
    case EMPLOYEE_FILTER_UPDATE: {
      return { ...action.values };
    }
    case EMPLOYEE_FILTER_CLEAR: {
      return {};
    }
    default:
      return state;
  }
}

export default function EmployeeFilter({ dispatch, selectedFilters, teamEmployees, width = '20%', selectedTaskType }) {
  const [selected, setSelected] = useState({});

  const selectedFilterIds = Object.entries(selectedFilters).reduce((ids, [value, isSelected]) => {
    isSelected && ids.push(value);
    return ids;
  }, []);

  function makeCurrentStateEqualToSelectedState() {
    const selected = {};
    selectedFilterIds.forEach((id) => (selected[id] = true));
    setSelected(selected);
  }

  function onSelect(value) {
    setSelected((selected) => ({ ...selected, [value]: !selected[value] }));
  }

  const onApply = useCallback(() => {
    dispatch({ type: EMPLOYEE_FILTER_UPDATE, values: { ...selected } });
    // document.body.click();
  }, [selected, EMPLOYEE_FILTER_UPDATE]);

  const onClickAway = useCallback(() => {
    if (isEmptyObject(selected)) {
      return null;
    }
    onApply();
  }, [selected, onApply]);

  const onClear = (e) => {
    e.stopPropagation();
    setSelected({});
    dispatch({ type: EMPLOYEE_FILTER_CLEAR });
    document.body.click();
  };

  const teamEmployeesWithSelectedOnTop = teamEmployees.sort(getFunctionForSortingSelectedAtTop(selected));

  const selectedCount = selectedFilterIds.length;
  return (
    <CustomMenu
      icon={
        <FilterDisplay
          width={width}
          icon={<EmployeeIconCircleIcon padding="1px" />}
          name="Employee Name"
          selectedCount={selectedCount}
          textColor={theme.palette.text.black}
          onClear={onClear}
        />
      }
      onOpen={makeCurrentStateEqualToSelectedState}
      onClickAway={onClickAway}
      menuType="employee_filter"
      onClick={() =>
        sendAppliedFilterEvent({
          eventProperties: {
            filter: 'Employee',
            source: selectedTaskType,
          },
        })
      }
    >
      <StyledDropdownList>
        <ScrollableContainer>
          {teamEmployeesWithSelectedOnTop.map((employee, index) => (
            <MenuItem
              onClick={onSelect.bind(null, employee.value)}
              value={employee.value}
              style={{ padding: 0 }}
              key={index}
            >
              {/* <Checkbox checked={Boolean(selected[employee.value])} color="primary" /> */}
              <DropdownListWrapper>
                <DropdownListElements
                  avatar={employee.avatar}
                  label={employee.label}
                  designation={employee.designation}
                  checked={Boolean(selected[employee.value])}
                  radioColor="primary"
                />
              </DropdownListWrapper>
              {/* <StyledTypography display="inline"></StyledTypography> */}
            </MenuItem>
          ))}
        </ScrollableContainer>
        {/* <ApplyMenuItem onClick={onApply}>
          <StyledTypography color="primary">Apply</StyledTypography>
        </ApplyMenuItem> */}
      </StyledDropdownList>
    </CustomMenu>
  );
}
